import loadable from '@loadable/component';

export default {
    sellergroup_infos: loadable(() => import('./InfosSellergroupModule')),
    sellergroup_mobilecta: loadable(() => import('./MobileCallToActionSellergroupModule')),
    sellergroup_alert_banner: loadable(() => import('./AlertBannerSellergroupModule')),
    sellergroup_presentation: loadable(() => import('./PresentationSellergroupModule')),
    sellergroup_banner: loadable(() => import('./BannerSellergroupModule')),
};
